// extracted by mini-css-extract-plugin
export default {"container":"ResourceSharing_container__SLRXp"};